module.exports = __webpack_public_path__ + "static/media/water.e26a5cf4.png";